/* eslint-disable no-undef */
export function composePhoneNumber(dial_code = '+66', phone_line_number) {
  if (dial_code === '+66' && phone_line_number.startsWith('+66')) {
    dial_code = ''
  }
  return `${dial_code}${phone_line_number.replace(/^0/g, '').replace(/[-()]/g, '')}`
}
